// WARNING: Do NOT change existing codes! Some of these are used by mobile and
// could break older versions of the app if changed!

export const ZenputCodes = {
    DOWN_STATE: 1000,
    NO_DATA_IN_RANGE: 1001,
    NO_FORM_TEMPLATE_SELECTED: 1002,
    PERMISSION_DENIED: 1003,
    UNICODE_IMPORT: 1004,
    UNKNOWN_ERROR: 1005,
    NO_DISTRIBUTE_GROUPS: 1006,
    NO_INGREDIENT_DATA: 1007,
    COMPANY_INACTIVE: 1008,
    VALIDATION_FAILURE: 1009,
    API_RATE_LIMIT: 2000
};
